import { ProductOperationDetailParams, ProductOperationDetailResponse } from '@repo/accounts-types'
import { Service } from '@repo/core'
import { AxiosRequestConfig } from 'axios'

export const getProductOperationDetail: Service<
  ProductOperationDetailParams,
  ProductOperationDetailResponse,
  Pick<AxiosRequestConfig, 'signal'>
> = async ({ api, params, config }) => {
  const { accountId, isinId, operationCode, productType } = params

  return api.get<ProductOperationDetailResponse>(
    `/accounts/securities/${accountId}/products/${isinId}/operations/${operationCode}`,
    { params: { productType }, ...config },
  )
}
